import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';
import { CloverObj } from '../../components/forms/CloverForm/types';
import { CloverFormErrors } from './types';

const CloverContext = createContext<{
  cloverObject: CloverObj;
  setCloverObject: React.Dispatch<React.SetStateAction<CloverObj>>;
  cloverFormErrors: CloverFormErrors;
  setCloverFormErrors: React.Dispatch<React.SetStateAction<CloverFormErrors>>;
}>({
  cloverObject: {},
  setCloverObject: () => {},
  cloverFormErrors: {},
  setCloverFormErrors: () => {},
});

export default CloverContext;


export const CloverProvider = ({ children }: { children: ReactNode }) => {
  const [cloverObject, setCloverObject] = useState({});
  const [cloverFormErrors, setCloverFormErrors] = useState({});

  const cloverValue = useMemo(
    () => ({
      cloverObject,
      setCloverObject,
      cloverFormErrors,
      setCloverFormErrors,
    }),
    [cloverFormErrors, cloverObject],
  );

  return (
    <CloverContext.Provider value={cloverValue}>
      {children}
    </CloverContext.Provider>
  );
};

export const useCloverContext = () => useContext(CloverContext);
